module.exports = __webpack_public_path__ + "static/media/joinus-banner.17a371aa.png";